/**
 * Mobile PDP: while the Buy Box "In den Warenkorb" button, the free towel promo or
 * the trust cards scroll through the corner where the Shopify Inbox chat button floats, the chat
 * button fades out (html.bekra-chat-yield, styled in assets/bekra-chat.css) so it
 * never covers them. One IntersectionObserver on a thin band around the chat
 * button's position - no scroll listener. The chat itself is not changed.
 * Loaded from snippets/bekra-sticky-quantity.liquid (product pages) and from the
 * homepage FAQ accordion in sections/bekra-application.liquid.
 */
const CLASS_NAME = 'bekra-chat-yield';
const TARGETS =
  '.product-information .buy-buttons-block, .product-information .bekra-towel-promo, .product-information .bekra-pdp-trust__grid, .bekra-application__accordion';
// Chat button: 44px high, bottom edge 160px (+ safe area) above the viewport bottom.
const BAND_TOP = 214;
const BAND_BOTTOM = 150;

const mobile = window.matchMedia('(max-width: 749px)');
/** @type {IntersectionObserver | null} */
let observer = null;
/** @type {number | undefined} */
let resizeTimer;

function setup() {
  observer?.disconnect();
  observer = null;
  document.documentElement.classList.remove(CLASS_NAME);

  const targets = document.querySelectorAll(TARGETS);
  if (!mobile.matches || targets.length === 0) return;

  const inBand = new Set();
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) inBand.add(entry.target);
        else inBand.delete(entry.target);
      }
      document.documentElement.classList.toggle(CLASS_NAME, inBand.size > 0);
    },
    { rootMargin: `-${Math.max(0, window.innerHeight - BAND_TOP)}px 0px -${BAND_BOTTOM}px 0px` }
  );
  targets.forEach((target) => observer?.observe(target));
}

setup();
mobile.addEventListener('change', setup);
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = window.setTimeout(setup, 200);
});
